import React, { useEffect, useRef, useState } from 'react';
import HeaderDesktop from '../../components/header/HeaderDesktop';
import { isMobile } from 'react-device-detect';
import HeaderMobileDetails from '../../components/header/HeaderMobileDetails';
// import ReactHtmlParser from 'react-html-parser';
import VideoPlayer from '../../components/CustomLibraries/VideoPlayer';
import VimeoPlayer from '../../components/vimeoPlayer/VimeoPlayer';
import queryString from 'query-string';
import { BannerItem, BannerWorker } from '.././../components/banner';
import { toast } from 'react-toastify';
import './css/sessionLive.scss';

import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLocalStorage,
  timeDifference,
  DEMO_USER_PICTURE,
  getCurrentTime,
  reactHtmlParser
} from '../../common/common';
import { getSessionDetail, requestJoining, reserveSession } from '../../Store/actions';
import useRedirect from '../../components/customHooks/useRedirect';
import { generateDataLayerGtm } from '../../helper/generateDataLayerGtm';
import QuestionAnswerChat from '../../components/qaChat/QuestionAnswerChat.jsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
import { TrackerComponent } from '../../TrackerFolder';
import { useTracker } from '../../TrackerFolder/TrackerComponent';
import { EVENT, PAGE_VIEW } from '../../TrackerFolder/constants/ActionType';
import { onPageView, trackEvent } from '../../TrackerFolder/actions/UserActions';

import { Seo } from '../../components/seo/seo';
SwiperCore.use([EffectFade, Autoplay]);
import LazyImage from '../../components/CustomLibraries/LazyImage';
import { Skeleton } from '../../skeleton/Skeleton';

let pageName = 'Live Session';
const LiveSession = () => {
  const { search } = useLocation();
  const { id, from_waiting_room } = queryString.parse(search);
  const dispatch = useDispatch();
  const userDetails = getLocalStorage('user', false) ? getLocalStorage('user', {}) : {};
  const [sessionId, setSessionId] = useState(id);
  const [sessionDoctorList, setSessionDoctorList] = useState([]);
  const [sessionTopic, setSessionTopic] = useState('');
  const [sessionDescription, setSessionDescription] = useState('');
  const [disclaimer, setDisclaimer] = useState('');
  const [loader, setLoader] = useState(true);
  const [vendorId, setVendorId] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [isIframe, setIsIframe] = useState(false);
  const [firstName, setFirstName] = useState(userDetails?.first_name ?? '');
  const [lastName, setLastName] = useState(userDetails?.last_name ?? '');
  const [color, setColor] = useState('0856cb');
  const [logo, setLogo] = useState([]);
  const { trackActivityEvent } = useTracker();
  const childFunc = useRef(null);
  const vimePlayerRef = useRef(null);
  const { redirectTo } = useRedirect();
  let evtSource = '';
  let commentsIterval = '';

  useEffect(() => {
    generateDataLayerGtm('Live Session');
    dispatch(
      getSessionDetail(id, (response) => {
        console.log('id-response', response);
        setLoader(false);
        if (response?.length > 0) {
          parseResponseJson(response);
        }
      })
    );

    return () => {
      if (typeof vimePlayerRef?.current == 'function') {
        vimePlayerRef.current();
      }
    };
  }, []);

  const parseResponseJson = (data) => {
    let sessionData = data[0];

    if (sessionData.vendor_id && (sessionData.vendor_id == 5 || sessionData.vendor_id == 0)) {
      setVendorId(sessionData.vendor_id);
      setVideoUrl(sessionData.video_embed_src);
    } else {
      // alert("invalid vendor");
    }

    if (sessionData.video_embed_src) {
      setIsIframe(sessionData.video_embed_src.includes('<iframe'));
    }

    setColor(sessionData.color_profress_bar ? sessionData.color_profress_bar : '0856cb');
    setSessionTopic(sessionData.session_topic);
    setSessionDoctorList(sessionData.session_doctor_entities);
    setSessionDescription(sessionData.session_description);
    setDisclaimer(sessionData.disclaimer);
    // setLogo(sessionData?.sponsor_logo?.split(","));
    setLogo(sessionData.sponsor_entities ?? []);
    console.log('IS WAITING ROOM', from_waiting_room);
    if (!sessionData?.is_booked) {
      let startTimeDif = timeDifference(sessionData?.start_datetime);
      let endTimeDif = timeDifference(sessionData?.start_datetime);
      startTimeDif = Math.round(startTimeDif);
      endTimeDif = Math.round(endTimeDif);
      const isLiveStart = startTimeDif >= 0 && endTimeDif <= 0;
      console.log('HEEEY JOIN 1');
      let parser = {
        session_id: id,
        question: '',
        my_participant_id: sessionData?.my_participant_id ?? '',
        attachFilePath: '',
        utm_source: '',
        redirect_to_live: isLiveStart ? 1 : 0,
        first_name: userDetails?.first_name,
        last_name: userDetails?.last_name
      };
      dispatch(
        reserveSession(parser, 'submit', (response) => {
          if (!from_waiting_room) {
            dispatch(requestJoining(id, (res) => {}));
          }
        })
      );
    } else {
      if (!from_waiting_room) {
        dispatch(requestJoining(id, (res) => {}));
      }
    }
  };

  return (
    <>
      {' '}
      <div className="w-100 float-start desktopBodyIn">
        <div className="container-fluid">
          <TrackerComponent page_name={pageName} module_page="session_details" page_id={id} />
          <Seo title={sessionTopic} description={sessionDescription} url={window.location.href} />
          <BannerWorker page_name={'session'} />
          {!isMobile && (
            <div className="w-100">
              {/* topBanner -- common.scss for testing */}
              <BannerItem position={'top'} page_name={'session'} />
            </div>
          )}
          <section className="w-100 cmnPageContent">
            {/* common for all page */}
            <div className="w-100 sessionLive">
              {/* page - start */}
              {/* "dtlsPageLive" - when live add className */}

              <div className="w-100 detailsPageLiveTop position-relative">
                {!loader ? (
                  <div className="detailsPageVideo bg-black mb-20 mb-lg-0">
                    {vendorId && vendorId == 5 && videoUrl ? (
                      // ReactHtmlParser(videoUrl)
                      <VimeoPlayer
                        data={{
                          src: videoUrl,
                          content_type: 'session',
                          content_id: sessionId
                        }}
                        videoRef={vimePlayerRef}
                      />
                    ) : (
                      <VideoPlayer
                        data={{
                          src: videoUrl,
                          content_type: 'session',
                          content_id: sessionId
                        }}
                        videoRef={childFunc}
                      />
                    )}
                  </div>
                ) : (
                  <div className="detailsPageVideo bg-black mb-20 mb-lg-0">
                    <Skeleton width={'100%'} height={500} />
                  </div>
                )}

                {/* {!loader && logo?.length > 0 && (
                    <div className="w-100 mobile_sponser d-lg-none d-flex align-items-center justify-content-between mb-3">
                      <h4 className="fs-4px text-black fw-medium">Powered By</h4>
                      <Swiper
                        className="crdV1sponser"
                        navigation={false}
                        spaceBetween={0}
                        slidesPerView={1}
                        loop={false}
                        autoplay={{
                          delay: 2500
                        }}
                        effect={'fade'}
                      >
                        <>
                          {logo.map((key,index) => (
                            <SwiperSlide key={index + 1}>
                              <img src={key.sponsor_logo} alt={key.sponsor_name} />
                            </SwiperSlide>
                          ))}
                        </>
                      </Swiper>
                    </div>
                  )} */}

                <div className="dtls_liveComment d-block position-absolute top-0 end-0 h-100">
                  <QuestionAnswerChat type={'session'} id={id} />
                </div>
              </div>

              {isMobile && (
                <div className="w-100 topBanner">
                  {/* topBanner -- common.scss for testing */}
                  <BannerWorker page_name={'session'} />
                  <BannerItem position={'top'} page_name={'session'} />
                </div>
              )}

              <div className="w-100 dtlsPageLeftBody">
                <div className="liveTttlArea text-start d-flex flex-column flex-lg-row justify-content-between mt-50">
                  <div className="liveTttlAreaLeft pe-0 pe-lg-20">
                    {!loader && sessionTopic ? (
                      <h2 className="text-black fs-2 fw-semibold ssnLiveTtl">{sessionTopic}</h2>
                    ) : loader ? (
                      <h2 className="text-black fs-2 fw-semibold">
                        <Skeleton variant="text" width={'90%'} />
                        <Skeleton variant="text" width={'70%'} />
                      </h2>
                    ) : null}
                    {!loader && sessionDescription ? (
                      <div className="w-100 text-black fs-16 ssnLiveAbout">
                        <p>{reactHtmlParser(sessionDescription)}</p>
                      </div>
                    ) : loader ? (
                      <div className="w-100 text-black fs-16">
                        <Skeleton variant="text" width={'100%'} />
                        <Skeleton variant="text" width={'60%'} />
                        <Skeleton variant="text" width={'50%'} />
                        <Skeleton variant="text" width={'40%'} />
                      </div>
                    ) : null}
                  </div>
                  {!loader && logo?.length > 0 && (
                    <Swiper
                      className="crdV1sponser position-relative text-end mt-4 ms-auto me-0 mt-lg-0"
                      navigation={false}
                      spaceBetween={0}
                      slidesPerView={1}
                      loop={false}
                      autoplay={{ delay: 2500 }}
                      effect={'fade'}
                    >
                      <>
                        {logo.map((key, index) => (
                          <SwiperSlide className="position-relative w-100" key={index + 1}>
                            <LazyImage
                              src={key.sponsor_logo}
                              className="position-absolute top-50 end-0 translate-middle-y mw-100 mh-100 w-auto h-auto"
                              alt={key.sponsor_name}
                              logo={true}
                            />
                          </SwiperSlide>
                        ))}
                      </>
                    </Swiper>
                  )}
                </div>
                <div className="w-100 liveSsn2DocArea mt-50">
                  <div className="row mt-n4 ms-n4">
                    {!loader &&
                      sessionDoctorList?.length > 0 &&
                      sessionDoctorList.map((key, index) => (
                        <div
                          className="col-xxl-4 col-lg-4 col-sm-6 col-12 text-start liveSsn2DocBox ps-4 mt-4"
                          key={index + 1}
                        >
                          <div className="w-100 liveSsn2DocBoxIn d-flex align-items-center shadow p-3 rounded">
                            <div className="liveSsn2DocPic position-relative overflow-hidden rounded-circle">
                              <LazyImage
                                src={key.session_doctor_image}
                                className="object-fit-cover w-100 h-100 float-start"
                                alt={key.session_doctor_name}
                                fallback_image={DEMO_USER_PICTURE}
                                logo={true}
                              />
                            </div>
                            <div className="w-100 liveSsn2DocContent position-relative ps-4">
                              {key.session_doctor_name && (
                                <h4 className="fs-3 text-black fw-semibold">
                                  {key.session_doctor_name}
                                </h4>
                              )}
                              <p className="fs-4 fw-normal">{key.subtitle}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="w-100 text-start fs-5 disclaimer mt-5 rounded bg-white">
                  {!loader && disclaimer && <h6 className="text-black fs-5 mb-2">Disclaimer</h6>}
                  {!loader && disclaimer && <p>{disclaimer}</p>}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default LiveSession;
